export const chatGraphemeLength = (text) => {
  if (typeof Intl.Segmenter !== 'function') {
    return Array.from(text).length;
  }

  return [...new Intl.Segmenter(undefined, {granularity: 'grapheme'}).segment(text)].length;
};

/**
 * 正規化済み本文とチャット単価倍率から利用トークン数を計算する。
 *
 * PHP側の対応する公開メソッドとテストは、仕様変更時に同時更新する。
 */
export const calculateChatTokenQuantity = (normalizedText, chatRate, tokenUnitLength) => {
  if (typeof normalizedText !== 'string'
    || !Number.isInteger(chatRate)
    || chatRate < 1
    || !Number.isInteger(tokenUnitLength)
    || tokenUnitLength < 1) {
    throw new TypeError('Invalid chat token calculation input.');
  }

  const length = chatGraphemeLength(normalizedText);
  if (length < 1 || length > 1500) {
    throw new RangeError('Invalid normalized chat message length.');
  }

  return Math.ceil(length / tokenUnitLength) * chatRate;
};

/**
 * 利用トークン数がチャットで利用可能な有効残数以下かを判定する。
 *
 * PHP側の対応する公開メソッドとテストは、仕様変更時に同時更新する。
 */
export const hasSufficientChatTokenBalance = (
  balances,
  useTokenQuantity,
  oshiPublicCustomerId,
  isFreeChatEnabled,
  currentDatetime,
) => {
  if (!Array.isArray(balances)
    || !Number.isInteger(useTokenQuantity)
    || useTokenQuantity < 1
    || typeof oshiPublicCustomerId !== 'string'
    || oshiPublicCustomerId === ''
    || typeof isFreeChatEnabled !== 'boolean'
    || !(currentDatetime instanceof Date)
    || Number.isNaN(currentDatetime.getTime())) {
    throw new TypeError('Invalid chat token validation input.');
  }

  let remainingQuantity = useTokenQuantity;
  for (const balance of balances) {
    if (!isAvailableBalance(balance, oshiPublicCustomerId, isFreeChatEnabled, currentDatetime)) {
      continue;
    }
    if (balance.quantity >= remainingQuantity) {
      return true;
    }
    remainingQuantity -= balance.quantity;
  }

  return false;
};

const isAvailableBalance = (balance, oshiPublicCustomerId, isFreeChatEnabled, currentDatetime) => {
  if (balance === null
    || typeof balance !== 'object'
    || !Number.isInteger(balance.quantity)
    || balance.quantity <= 0
    || (balance.token_type !== 1
      && balance.token_type !== 4
      && !(isFreeChatEnabled && balance.token_type === 2))
    || (balance.oshi_public_customer_id !== null
      && String(balance.oshi_public_customer_id) !== oshiPublicCustomerId)) {
    return false;
  }

  if (balance.expires_at === null) {
    return true;
  }
  const expiresAt = new Date(balance.expires_at);

  return !Number.isNaN(expiresAt.getTime()) && expiresAt.getTime() >= currentDatetime.getTime();
};
